import SecureLS from 'secure-ls';
const ls = new SecureLS({encodingType: 'aes'});
let debugMode = false

export function setLsData(key, value){
  try{
    if(!debugMode){
      ls.set(key, {data: value});
    }else{
      if(typeof value == 'object'){
        value = JSON.stringify(value)
      }
      localStorage.setItem(key, value);
    }
  }catch(err){
    // console.log("err::", err);
  }
}

export function getLsData(key, callee){
  // console.log("callee", callee)
  try{
    if(!debugMode){
      if(ls.get(key)){
        // console.log("key", typeof(ls.get(key).data), ls.get(key).data)
        return ls.get(key).data;
      }
    }else{
      if(localStorage.getItem(key).indexOf('{') != -1 ){
        return JSON.parse(localStorage.getItem(key));
      }else{
        return JSON.parse(localStorage.getItem(key))
      }
    }
  }catch(err){
    // console.log("err::", err);
  }
}

export function removeLsData(key){
  try{
    if(!debugMode){
      ls.remove(key);
    }else{
      localStorage.removeItem(key);
    }
  }catch(err){
    console.log("err::", err);
  }
}

export default ls;